import { ISpecialistByIdData } from '../../../1_shared/config/interfaces/ISpecialistByIdData';

import 'swiper/scss';
import 'app/styles/global/global.scss';
import './specialist-theme.scss'; // Импортируем нужные нам стили
import './specialist-quote.scss';
import './specialist-meeting.scss';

const AboutSpecialist = ({ spec }: { spec: ISpecialistByIdData }) => (
  // оборачиваем html код в стрелочную функцию, перед этим необходимо назвать файл *.tsx, где * - это название вашего шаблона
  <div>
    {spec.aboutYourself && (
      <section className="specialist-quote">
        <div className="specialist-quote__container container">
          <h2 className="specialist-quote__title section-title">
            Цитата о себе
          </h2>
          <div className="specialist-quote__content-mobile">
            <p>{spec.aboutYourself}</p>
          </div>
        </div>
      </section>
    )}
  </div>
);

export default AboutSpecialist; // експортируем функцию от сюда
